const revealOnScroll = (items, options = {}) => {
	const elements = Array.from(items || [])
	const visibleClass = options.visibleClass || "visible"
	const stagger = options.stagger || 0
	const observerOptions = options.observerOptions || { threshold: 0.15 }
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

	if (!elements.length) {
		return
	}

	const revealElement = (element, index = 0) => {
		window.setTimeout(() => {
			element.classList.add(visibleClass)
		}, index * stagger)
	}

	if (prefersReducedMotion || typeof IntersectionObserver === "undefined") {
		elements.forEach(revealElement)
		return
	}

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				return
			}

			revealElement(entry.target, elements.indexOf(entry.target))
			observer.unobserve(entry.target)
		})
	}, observerOptions)

	elements.forEach(element => observer.observe(element))
}

export default revealOnScroll
